import { render, staticRenderFns } from "./miniappPanneEditDialog.vue?vue&type=template&id=c789cbb4"
import script from "./miniappPanneEditDialog.vue?vue&type=script&lang=js"
export * from "./miniappPanneEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports